import { extractActionsApi } from '../../../api/actionImportApi'
import { ExtractActionsResponse } from '../../../types/actionImportTypes'

export type JiraConnection = {
  /** Jira credentials and project key live in the task-extractor `.env`, never in the browser. */
  configuredOnServer: true
  issues: ExtractActionsResponse
}

/**
 * Single entry point for the Jira source of the action import wizard.
 *
 * TODO(jira-connect): replace with the real Jira connection backend once it exists
 * (OAuth/site selection, project listing, JQL filters). Today the server uses the
 * fixed JIRA_URL / JIRA_PROJECT_KEY of the task-extractor service and returns the
 * last 100 issues of that project, so "connecting" and "fetching issues" are the
 * same request.
 */
export const jiraImportAdapter = {
  async connect(signal?: AbortSignal): Promise<JiraConnection> {
    const issues = await extractActionsApi({ source: 'jira', signal })
    return { configuredOnServer: true, issues }
  },
}
